import React from "react";

export const Demo = () => {
  return (
    <div id="demo" className="demo-section">
      <div className="container">
        <div className="section-title">
          <h2>See Peak Risk Management in Action</h2>
          <p>Watch our comprehensive demo to understand how our platform can transform your risk management</p>
        </div>
        
        <div className="demo-container">
          <div className="demo-video">
            <div 
              style={{
                position: 'relative',
                boxSizing: 'content-box',
                maxHeight: '80vh',
                width: '100%',
                aspectRatio: '1.8274111675126903',
                padding: '40px 0 40px 0'
              }}
            >
              <iframe 
                src="https://app.supademo.com/embed/cmfndmzq50hys1d3niy6dcmvf?v_email=EMAIL&embed_v=2&utm_source=embed&utm_medium=iframe&utm_campaign=peakrmis&utm_content=demo" 
                loading="lazy" 
                title="Peakrmis Demo" 
                allow="clipboard-write" 
                frameBorder="0" 
                webkitAllowFullScreen={true} 
                mozAllowFullScreen={true} 
                allowFullScreen 
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }}
              />
            </div>
          </div>
          
          <div className="demo-cta">
            <p><b>Why not dive right in and get a feel for how Peak Risk Management can help your employees stay safe and your business thrive!</b></p>
            <p>Contact us below to learn more about how Peak Risk Management can help your business!</p>
            <a href="#contact" className="btn btn-secondary">
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
